module.exports = __webpack_public_path__ + "static/img/PT@3x.624c38bc.jpg";